import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum OpportunityTypeIds {
  NEW = 1,
  ADD_ON = 2,
  UPGRADE = 3,
  RENEWAL = 4,
}

export function getOpportunityTypes(): ISelectItem[] {
  return [
    { id: OpportunityTypeIds.NEW, label: 'New' },
    { id: OpportunityTypeIds.ADD_ON, label: 'Add-On' },
    { id: OpportunityTypeIds.UPGRADE, label: 'Upgrade' },
    { id: OpportunityTypeIds.RENEWAL, label: 'Renewal' },
  ]
}

export const getOpportunityTypeByLabel =
  getItemByLabelFactory(getOpportunityTypes)

export const getOpportunityTypeById = getItemByIdFactory(getOpportunityTypes)
